import { arenaUrlForHostname, isHostedArenaHostname } from './arena'
import { isSteamClient } from './steam'
import {
  getLegacyQueryLanguage,
  getPathLanguage,
  withLanguagePath,
} from './url-language-utils'

const PERSPECTIVE_HASH_KEY = 'watch'

export interface PerspectiveShareLocation {
  hostname: string
  origin: string
  pathname: string
  search?: string
  steamClient?: boolean
}

export function perspectiveTokenFromHash(hash: string): string | null {
  const fragment = hash.startsWith('#') ? hash.slice(1) : hash
  const token = new URLSearchParams(fragment).get(PERSPECTIVE_HASH_KEY)
  return token || null
}

export function perspectiveShareUrl(
  gameId: string,
  token: string,
  location: PerspectiveShareLocation | null
    = typeof window === 'undefined' ? null : window.location,
): string {
  const encodedGameId = encodeURIComponent(gameId)
  const encodedToken = encodeURIComponent(token)
  const language = location
    ? getPathLanguage(location.pathname)
    ?? getLegacyQueryLanguage(location.search ?? '')
    ?? 'en'
    : 'en'
  const path = withLanguagePath(`/play/${encodedGameId}`, language)
  const steamClient = location?.steamClient
    ?? (typeof window !== 'undefined' && location === window.location
      && isSteamClient())
  const hostedArenaOrigin = location && !steamClient
    ? arenaUrlForHostname(location.hostname)
    : null
  const arenaOrigin = location
    ? hostedArenaOrigin ?? location.origin
    : 'https://werewolf.mentiss.ai'
  const url = new URL(path, arenaOrigin)
  if (location && !hostedArenaOrigin
    && !isHostedArenaHostname(location.hostname) && !steamClient) {
    url.searchParams.set('arena', '')
  }
  url.hash = `${PERSPECTIVE_HASH_KEY}=${encodedToken}`
  return url.toString()
}

export async function perspectiveTokenFingerprint(
  token: string,
): Promise<string> {
  const input = new TextEncoder().encode(token)
  const digest = await crypto.subtle.digest('SHA-256', input)
  return Array.from(new Uint8Array(digest), byte =>
    byte.toString(16).padStart(2, '0')).join('')
}
